import React from 'react';

import { SVGPropsType } from 'src/types';

function AreaChart(props: SVGPropsType) {
    const { stroke, fill, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M2 9L3.8 7L7 8.5L8.9 5.4L12 5.5L14 3"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="1.70039" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="1.70039" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="1.70039" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="2.7502" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="2.7502" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="2.7502" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="2.7502" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="3.80049" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="3.80049" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="3.80049" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="3.80049" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="3.80049" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="4.85029" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="4.85029" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="4.85029" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="4.85029" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="4.85029" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="5.90059" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="5.90059" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="5.90059" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="5.90059" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="6.95039" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="6.95039" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="6.95039" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="6.95039" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="8.0002" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="8.0002" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="8.0002" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="8.0002" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="9.05049" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="9.05049" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="9.05049" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="9.05049" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="9.05049" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="7.2198" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="8.2798" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="10.1003" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="7.2198" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="8.2798" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="11.1506" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="7.2198" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="8.2798" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="12.2004" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="7.2198" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="8.2798" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="13.2502" cy="13.5798" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="5.0998" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="6.1598" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="7.2198" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="8.2798" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="9.3398" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="10.3998" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="11.4598" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="12.5198" r="0.3" fill={fill} />
            <circle cx="14.3005" cy="13.5798" r="0.3" fill={fill} />
        </svg>
    );
}

export default AreaChart;
